module.exports = __webpack_public_path__ + "img/facebook.7c3c743b.svg";